import { cn } from "@/lib/utils";

/**
 * Shared card surface for every Auth screen (login, MFA, tenant select,
 * passkey enrollment, session expired). Provides the white surface, border,
 * radius, shadow, and internal padding defined by `.auth-card` in
 * globals.css — previously only `/login` applied this treatment manually.
 *
 * `variant="wide"` widens the content column for rows that need more
 * horizontal room (e.g. tenant select's org rows with badges). Exact
 * widths are provisional pending Figma comparison (see
 * analysis/AUTH_RESPONSIVE_VISUAL_AUDIT.md, §7 and §14).
 */
export function AuthCard({
  variant = "standard",
  className,
  children,
}: {
  variant?: "standard" | "wide";
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("auth-card", variant === "wide" && "auth-card--wide", className)}>
      <div className="auth-card__inner">
        <div className="auth-card__content">{children}</div>
      </div>
    </div>
  );
}
